import api from 'api';

// Story sponsorship (research). Called on the raw axios instance, like
// api/faq-sponsor.js, so the API's message and code reach the page.

const unwrap = (res) => res.data.data;

// The alert page is cached; this is the box's live status. Null when not on offer.
export const fetchResearchSponsorship = async (alertId) =>
    unwrap(await api.get(`/research-sponsorship/${alertId}`));

// The strip under an open alert's headline: { price } while the offer is for sale, else null.
export const fetchResearchStrip = async (alertId) =>
    unwrap(await api.get(`/research-sponsorship/${alertId}/strip`));

// The offer's text and price, for logged-in experts only. Null when there is none for them.
export const fetchResearchOffer = async (alertId) =>
    unwrap(await api.get(`/research-sponsorship/${alertId}/offer`));

export const fetchResearchSponsorshipAdmin = async (alertId) =>
    unwrap(await api.get(`/research-sponsorship/${alertId}/admin`));

export const saveResearchOffer = async (alertId, body) =>
    unwrap(await api.put(`/research-sponsorship/${alertId}`, body));

// { status, url?, reservationToken? }. Logged-in experts only: `api` carries the member's token.
export const reserveResearchSponsorship = async (alertId, body) =>
    unwrap(await api.post(`/research-sponsorship/${alertId}/reserve`, body));

export const releaseResearchSponsorship = async (alertId, reservationToken) =>
    unwrap(
        await api.post(`/research-sponsorship/${alertId}/release`, {
            reservationToken,
        })
    );

// Sold only: hide the box and the credit, or show them again.
export const setResearchSponsorHidden = async (alertId, hidden) =>
    unwrap(
        await api.put(`/research-sponsorship/${alertId}/sponsor`, { hidden })
    );

// Reserved only. { status } is where the slot ended up. confirmedInStripe: the
// editor has checked the session in Stripe, so one completed unpaid is released too.
export const forceReleaseResearchSponsorship = async (
    alertId,
    confirmedInStripe = false
) =>
    unwrap(
        await api.post(
            `/research-sponsorship/${alertId}/force-release`,
            confirmedInStripe ? { confirmedInStripe } : undefined
        )
    );
